export default [
  {
    id: 21,
    value: '资讯',
    children: [
      {
        id: 2101,
        value: '摄影'
      },
      {
        id: 2102,
        value: '汽车'
      },
      {
        id: 2103,
        value: '婚庆'
      },
      {
        id: 2104,
        value: '科技'
      },
      {
        id: 2105,
        value: '娱乐时尚'
      },
      {
        id: 2106,
        value: '健康生活'
      },
      {
        id: 2107,
        value: '家居园艺'
      },
      {
        id: 2108,
        value: '文学与艺术'
      },
      {
        id: 2109,
        value: '新闻'
      },
      {
        id: 2110,
        value: '财经'
      },
      {
        id: 2111,
        value: '宠物动物'
      },
      {
        id: 2113,
        value: '情感与两性'
      },
      {
        id: 2114,
        value: '房产建筑'
      },
      {
        id: 2115,
        value: '法律'
      },
      {
        id: 2199,
        value: '其他'
      }
    ]
  },
  {
    id: 22,
    value: '财务',
    children: [
      {
        id: 2201,
        value: '银行证券'
      },
      {
        id: 2202,
        value: '无线支付'
      },
      {
        id: 2203,
        value: '理财工具'
      },
      {
        id: 2204,
        value: '计算工具'
      },
      {
        id: 2205,
        value: '彩票'
      },
      {
        id: 2299,
        value: '其他'
      }
    ]
  },
  {
    id: 23,
    value: '交通（导航）',
    children: [
      {
        id: 2301,
        value: '地图导航'
      },
      {
        id: 2302,
        value: '交通查询'
      },
      {
        id: 2303,
        value: '车位路况'
      },
      {
        id: 2304,
        value: '租车打的'
      },
      {
        id: 2399,
        value: '其他'
      }
    ]
  },
  {
    id: 24,
    value: '系统',
    children: [
      {
        id: 2401,
        value: '安全工具'
      },
      {
        id: 2402,
        value: '系统优化'
      },
      {
        id: 2403,
        value: '应用管理'
      },
      {
        id: 2404,
        value: '通讯工具'
      },
      {
        id: 2405,
        value: '二维码扫描'
      },
      {
        id: 2406,
        value: '浏览器'
      },
      {
        id: 2407,
        value: '备份与云存储'
      },
      {
        id: 2408,
        value: '输入法'
      },
      {
        id: 2409,
        value: '格式转化'
      },
      {
        id: 2499,
        value: '其他'
      }
    ]
  },
  {
    id: 25,
    value: '健康',
    children: [
      {
        id: 2501,
        value: '怀孕母婴'
      },
      {
        id: 2502,
        value: '减肥健身'
      },
      {
        id: 2503,
        value: '药品查询'
      },
      {
        id: 2504,
        value: '疾病咨询'
      },
      {
        id: 2505,
        value: '运动指导'
      },
      {
        id: 2506,
        value: '两性'
      },
      {
        id: 2599,
        value: '其他'
      }
    ]
  },
  {
    id: 26,
    value: '教育',
    children: [
      {
        id: 2601,
        value: '儿童'
      },
      {
        id: 2602,
        value: '词典'
      },
      {
        id: 2603,
        value: '英语'
      },
      {
        id: 2604,
        value: '职场技能'
      },
      {
        id: 2605,
        value: '自然科学'
      },
      {
        id: 2606,
        value: '人文历史'
      },
      {
        id: 2607,
        value: '经济财经'
      },
      {
        id: 2608,
        value: '网络课程'
      },
      {
        id: 2699,
        value: '其他'
      }
    ]
  },
  {
    id: 27,
    value: '旅行',
    children: [
      {
        id: 2701,
        value: '旅游信息'
      },
      {
        id: 2702,
        value: '旅游攻略'
      },
      {
        id: 2703,
        value: '酒店餐饮'
      },
      {
        id: 2704,
        value: '票务查订'
      },
      {
        id: 2799,
        value: '其他'
      }
    ]
  },
  {
    id: 28,
    value: '美食',
    children: [
      {
        id: 2801,
        value: '美食资讯'
      },
      {
        id: 2802,
        value: '美食菜谱'
      },
      {
        id: 2803,
        value: '团购优惠'
      },
      {
        id: 2804,
        value: '本地订餐'
      },
      {
        id: 2899,
        value: '其他'
      }
    ]
  },
  {
    id: 29,
    value: '商业',
    children: [
      {
        id: 2901,
        value: '求职'
      },
      {
        id: 2902,
        value: '人脉管理'
      },
      {
        id: 2903,
        value: '商业沟通'
      },
      {
        id: 2904,
        value: '营销运营'
      },
      {
        id: 2905,
        value: '移动办公'
      },
      {
        id: 2999,
        value: '其他'
      }
    ]
  },
  {
    id: 30,
    value: '购物',
    children: [
      {
        id: 3001,
        value: '购物指南'
      },
      {
        id: 3002,
        value: '购物商城'
      },
      {
        id: 3003,
        value: '团购'
      },
      {
        id: 3099,
        value: '其他'
      }
    ]
  },
  {
    id: 31,
    value: '社交',
    children: [
      {
        id: 3101,
        value: '社交通讯'
      },
      {
        id: 3102,
        value: '问答'
      },
      {
        id: 3103,
        value: '社区论坛'
      },
      {
        id: 3199,
        value: '其他'
      }
    ]
  },
  {
    id: 32,
    value: '影像',
    children: [
      {
        id: 3201,
        value: '影像管理'
      },
      {
        id: 3202,
        value: '影像编辑美化'
      },
      {
        id: 3203,
        value: '壁纸美化'
      },
      {
        id: 3204,
        value: '影像播放'
      },
      {
        id: 3299,
        value: '其他'
      }
    ]
  },
  {
    id: 33,
    value: '生活',
    children: [
      {
        id: 3301,
        value: '天气情况'
      },
      {
        id: 3302,
        value: '计时闹钟'
      },
      {
        id: 3399,
        value: '其他'
      }
    ]
  },
  {
    id: 34,
    value: '体育',
    children: [
      {
        id: 3401,
        value: '体育指导'
      },
      {
        id: 3402,
        value: '运动资讯'
      },
      {
        id: 3499,
        value: '其他'
      }
    ]
  },
  {
    id: 35,
    value: '图书',
    children: [
      {
        id: 3501,
        value: '阅读软件'
      },
      {
        id: 3502,
        value: '图书资源'
      },
      {
        id: 3599,
        value: '其他'
      }
    ]
  },
  {
    id: 36,
    value: '效率',
    children: [
      {
        id: 3601,
        value: '日程管理'
      },
      {
        id: 3602,
        value: '邮件管理'
      },
      {
        id: 3603,
        value: '备忘记录'
      },
      {
        id: 3604,
        value: '量度工具'
      },
      {
        id: 3605,
        value: '扫描工具'
      },
      {
        id: 3606,
        value: '办公室软件'
      },
      {
        id: 3699,
        value: '其他'
      }
    ]
  },
  {
    id: 37,
    value: '娱乐',
    children: [
      {
        id: 3701,
        value: '电影音乐'
      },
      {
        id: 3702,
        value: '视频播放'
      },
      {
        id: 3703,
        value: '音乐管理'
      },
      {
        id: 3704,
        value: '游戏大厅'
      },
      {
        id: 3705,
        value: '占卜风水'
      },
      {
        id: 3706,
        value: '语录笑话'
      },
      {
        id: 3707,
        value: '漫画'
      },
      {
        id: 3708,
        value: '画图工具'
      },
      {
        id: 3709,
        value: '虚拟宠物'
      },
      {
        id: 3799,
        value: '其他'
      }
    ]
  },
  {
    id: 38,
    value: '游戏',
    children: [
      {
        id: 3801,
        value: '在线网游'
      },
      {
        id: 3802,
        value: '儿童游戏'
      },
      {
        id: 3803,
        value: '棋牌游戏'
      },
      {
        id: 3804,
        value: '教育游戏'
      },
      {
        id: 3805,
        value: '街机游戏'
      },
      {
        id: 3806,
        value: '益智休闲游戏'
      },
      {
        id: 3807,
        value: '体育游戏'
      },
      {
        id: 3808,
        value: '动作游戏'
      },
      {
        id: 3809,
        value: '角色扮演游戏'
      },
      {
        id: 3810,
        value: '策略游戏'
      },
      {
        id: 3811,
        value: '赛车游戏'
      },
      {
        id: 3812,
        value: '音乐游戏'
      },
      {
        id: 3899,
        value: '其他'
      }
    ]
  },
  {
    id: 99,
    value: '其他'
  }
]
